import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { keywordsApi } from '../api/keywords';
import type { KeywordResourceType } from '../api/keywords';

export function useKeywordSets(resourceType?: KeywordResourceType, page = 1) {
  return useQuery({
    queryKey: ['keywords', { resourceType, page }],
    queryFn: () => keywordsApi.list({ resource_type: resourceType, page }),
  });
}

export function useKeywordSet(id: number | null) {
  return useQuery({
    queryKey: ['keywords', id],
    queryFn: () => keywordsApi.find(id!),
    enabled: id !== null,
  });
}

export function useGenerateKeywords() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: keywordsApi.generate,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['keywords'] }),
  });
}

export function useDeleteKeywordSet() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: keywordsApi.destroy,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['keywords'] }),
  });
}
